const { TKIconSearch } = require("assets/images/svgs");
const { default: InputField } = require("./InputField");

const SearchField = ({
  gradient,
  className,
  placeholder,
  name,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
}) => {
  return (
    <div className={`relative ${className}`}>
      <InputField
        className="!px-8 max-md:!pl-8 max-md:!pr-2"
        gradient={gradient}
        type="text"
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
      <TKIconSearch className="absolute stroke-black left-2 bottom-[30%]" />
    </div>
  );
};

export default SearchField;
